<script setup lang="ts">
import logo from '../../../assets/srovnejto_logo.svg?url'

const props = defineProps<{
  modelValue?: boolean
  redirectFromLogo?: StoryBlokImage
  item?: {
    link: StoryBlokLink
    name: string
    logo: StoryBlokImage
  }
}>()
const emit = defineEmits(['update:modelValue'])

const timeToRedirect = ref(3)
let redirectInterval: NodeJS.Timer
function close() {
  emit('update:modelValue', false)
  timeToRedirect.value = 3
  clearInterval(redirectInterval)
}

function redirectInNewWindow() {
  const newTab = window.open()
  newTab!.window.location.href = props.item!.link.cached_url!
  close()
}

watch(
  () => props.modelValue,
  (val) => {
    if (val) {
      redirectInterval = setInterval(() => {
        if (timeToRedirect.value)
          timeToRedirect.value -= 1

        else
          redirectInNewWindow()
      }, 1000)
    }
  },
)
</script>

<template>
  <BaseModal :model-value="modelValue" @close="close()">
    <template #header>
      <h3>
        Za <span class="inline-block min-w-[16px]">{{ timeToRedirect }}</span>s vás přesměrujeme na stránky {{ item?.name }}
      </h3>
    </template>

    <template #content>
      <div class="mt-3 text-[18px]">
        Děkujeme za využití našich služeb.
      </div>
      <div class="my-15 flex flex-col md:flex-row items-center justify-center gap-5">
        <img
          width="180"
          :src="redirectFromLogo ? redirectFromLogo.filename : logo"
          :alt="redirectFromLogo ? redirectFromLogo.name : 'srovnejto logo'"
          loading="lazy"
        >
        <div class="h-[140px] md:w-[140px] md:h-full self-center">
          <AppIcon class="arrow relative" size="30" icon="far-angle-right" />
        </div>
        <img class="w-max" :src="item?.logo.filename" :alt="item?.name">
      </div>
      <StoryblokButton class="w-full" text="Přejít hned" :link="{ ...item!.link }" target="_blank" @click="close()" />
    </template>
  </BaseModal>
</template>

<style lang="scss" scoped>
  @keyframes loading-redirect {
    0% {
      opacity: 0;
      left: 0px;
    }
    33% {
      opacity: 0.33;
      left: 33px;
    }
    66% {
      opacity: 0.66;
      left: 66px;
    }
    100% {
      opacity: 1;
      left: 100px;
    }
  }
  @keyframes loading-redirect-vertical {
    0% {
      opacity: 0;
      top: 0px;
    }
    33% {
      opacity: 0.33;
      top: 33px;
    }
    66% {
      opacity: 0.66;
      top: 66px;
    }
    100% {
      opacity: 1;
      top: 100px;
    }
  }
  .arrow {
    animation-iteration-count: infinite;
    animation-duration: 1.5s;
  }
  @media only screen and (max-width: 768px) {
    .arrow {
      animation-name: loading-redirect-vertical;
      transform: rotate(90deg);
    }
  }
  @media only screen and (min-width: 768px) {
    .arrow {
      animation-name: loading-redirect;
    }
  }
</style>
